import { Title } from "@mantine/core";
import { Link } from "react-router";
import NodeEnergyLogo from "../../assets/default/img/node.energy lowercase.png";
import { SiteName } from "../../utils/enums";
import { FooterMenu } from "./FooterMenu";
import "./PublicLayout.scss";
import { SiteLogo } from "./SiteLogo";
import { getPublicLayoutLogo } from "./utils/getPublicLayoutLogo";

declare const SITE_NAME: SiteName;

interface PublicLayoutProps {
  children: React.ReactNode;
}

export function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <div className="LayoutContainer">
      <div className="LayoutGradient">
        <div className="LogoWhite">
          <img
            alt="Logo white"
            src={getPublicLayoutLogo(SITE_NAME)}
            width={SITE_NAME === SiteName.Alva ? 80 : 30}
          />
        </div>

        <Title c="white" fw={600} fz="5rem" lh="7rem" order={1}>
          So einfach <br /> ist Energie.
        </Title>
      </div>

      <div className="LayoutContent">
        <div className="OptiNodeLogo">
          <Link to="/login">
            <SiteLogo siteName={SITE_NAME} />
          </Link>
        </div>

        {children}

        <div>
          <div className="LayoutFooterProductLogo">
            <span className="ProductByText">Product by</span>
            <img alt="node.energy logo" src={NodeEnergyLogo} width={100} />
          </div>

          <div>
            <FooterMenu siteName={SITE_NAME} strongLinks />
          </div>
        </div>
      </div>
    </div>
  );
}
